@if (shouldShow) {
    <div class="downtime-banner" role="status" aria-live="polite">
        <div class="downtime-banner__content">
            <img
                class="downtime-banner__icon"
                [src]="mascotSrc"
                alt=""
                width="56"
                height="56"
            />
            <div class="downtime-banner__text">
                <p class="downtime-banner__message">{{ message }}</p>
                @if (periodLabel) {
                    <p class="downtime-banner__period">{{ periodLabel }}</p>
                }
            </div>
        </div>
    </div>
}
